module.exports = __webpack_public_path__ + "static/media/AmandaVarella.f45ef2a0.jpg";